import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
// import Blog from './pages/Blog';
import Users from './pages/Users';
import Apps from './pages/Apps'
import { AppCard } from './sections/@dashboard/apps';
import AppInfoPage from './sections/@dashboard/apps/AppInfoPage';
import UserPage from './sections/@dashboard/user/UserPage';
import UserAppsPage from './sections/@dashboard/user/UserAppsPage';
import UserActionsPage from './sections/@dashboard/user/UserActionsPage'
import Login from './pages/Login';
import NotFound from './pages/Page404';
import Register from './pages/Register';
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ChangePasswordPage from './pages/ChangePasswordPage'
import Products from './pages/Products';
import { ProductCard } from './sections/@dashboard/products';
import DashboardApp from './pages/DashboardApp';
import UserSentPage from './sections/@dashboard/user/UserSentPage';
import ReviewsPage from './sections/@dashboard/apps/ReviewsPage';
import UserProfile from './sections/@dashboard/user/UserProfile';
import SettingsPage from './pages/SettingsPage';
import UserMessages from './sections/@dashboard/user/UserMessages';
import AppRevenue from './sections/@dashboard/apps/AppRevenue';
import UserSubscription from './sections/@dashboard/user/UserSubscription';
import SearchPage from './pages/SearchPage';
import PaymentPeriod from './sections/@dashboard/user/SelectPayment'
import UserSubscriptionPage from './sections/@dashboard/user/UserSubscriptionPage';
import PaywallNotActive from './pages/PaywallNotActive';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Apps /> },
        { path: 'apps', element: <Apps /> },
        { path: 'apps/:app_id/reviews', element: <ReviewsPage /> },
        { path: 'apps/:app_id/info', element: <AppInfoPage /> },
        { path: 'apps/:app_id/revenue', element: <AppRevenue /> },
        { path: 'apps/:app_id', element: <AppCard /> },


        { path: 'users', element: <Users /> },
        { path: 'users/:user_id/apps', element: <UserAppsPage /> },
        { path: 'users/:user_id/actions', element: <UserActionsPage /> },
        { path: 'users/:user_id/sent', element: <UserSentPage /> },
        { path: 'users/:user_id/messages', element: <UserMessages /> },
        { path: 'users/:user_id/subscription', element: <UserSubscription /> },
        { path: 'users/:user_id/', element: <UserPage /> },
        { path: 'profile', element: <UserProfile /> },
        { path: 'subscription', element: <UserSubscriptionPage /> },
        { path: 'payment', element: <PaymentPeriod /> },
        { path: 'search', element: <SearchPage /> },
        { path: 'settings', element: <SettingsPage /> },
        // { path: 'products', element: <Products /> },
      ],
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'register',
      element: <Register />,
    },
    {
      path: 'forgot_password',
      element: <ForgotPasswordPage />,
    },
    {
      path: 'reset-password',
      element: <ChangePasswordPage />,
    },

    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/apps" /> },
        { path: '404', element: <NotFound /> },
        { path: 'unactive', element: <PaywallNotActive /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },

    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);
}
